function cacheBustUrl(url) {
  const ver = Math.floor(Date.now() / 1000);
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}ver=${ver}`;
}

export async function fetchStaticJson(url) {
  const link = cacheBustUrl(url);
  const res = await fetch(link);

  if (!res.ok) {
    throw new Error(`Failed to fetch json url: ${url} with status: ${res.status}`);
  }

  return res.json();
}
